<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="活动">
                    <el-input v-model="query.keyword" placeholder="活动标题" clearable></el-input>
                </el-form-item>

                <el-form-item label="参与时间">
                    <div class="block">
                        <span class="demonstration"></span>
                        <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
<!--        &lt;!&ndash;添加等级&ndash;&gt;-->
<!--        <div class="common-level-rail">-->
<!--            <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus" v-auth="'/education/activity/activity/add'">添加活动</el-button>-->
<!--        </div>-->
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="enroll_id" label="ID" width="80"></el-table-column>
                    <el-table-column prop="activity_title" label="活动">
                        <template slot-scope="scope">
                            {{  scope.row.activity ? scope.row.activity.title : '' }} <br>
                        </template>
                    </el-table-column>

                    <el-table-column prop="user_nickname" label="活动类型" width="150">
                        <template slot-scope="scope">
                            {{  scope.row.activity ? scope.row.activity.activity_type_desc : '' }} <br>
                        </template>
                    </el-table-column>

                    <el-table-column prop="activity_title" label="提交用户" width="150">
                        <template slot-scope="scope">
                            {{  scope.row.user ? scope.row.user.nickName : '' }} <br>
                        </template>
                    </el-table-column>

                    <el-table-column prop="name" label="姓名" width="150">
                        <template slot-scope="scope">
                            {{  scope.row.name ? scope.row.name : '' }} <br>
                        </template>
                    </el-table-column>

                    <el-table-column prop="mobile" label="联系电话" width="150">
                        <template slot-scope="scope">
                            {{  scope.row.mobile ? scope.row.mobile : '' }} <br>
                        </template>
                    </el-table-column>

<!--                    <el-table-column prop="status_desc" label="状态" width="150"></el-table-column>-->
<!--                    <el-table-column prop="sort" label="排序" width="60"></el-table-column>-->
                    <el-table-column prop="create_time" label="参与时间" width="150"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button @click="handleDetail(scope.row)" type="text" size="small" v-auth="'/education/activity/enrollDetail'">详情</el-button>
<!--                            <el-button @click="handlAudit(scope.row)" type="text" size="small" v-auth="'/education/activity/activity/audit'">审核</el-button>-->
<!--                            <el-button @click="handleDelete(scope.row)" type="text" size="small" v-auth="'/education/activity/activity/del'">删除</el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="query.page"
                        :page-size="query.list_rows"
                        layout="total, prev, pager, next, jumper"
                        :total="total"></el-pagination>
            </div>
        </div>
        <!--添加编辑-->
        <edit ref="edit" @fetch-data="search"></edit>
        <audit ref="audit" @fetch-data="search" />
        <detail ref="detail" />
    </div>
</template>

<script>
    import { enrollList, voteDel } from '@/api/education';
    import Edit from './edit.vue';
    import Audit from '@/views/education/audit/audit';
    import Detail from '@/views/education/activity/enroll/detail';

    export default {
        components: {
            /*编辑组件*/
            Edit,
            Audit,
            Detail,
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                total: 0,
                /*横向表单数据模型*/
                form: {
                    become: '0'
                },
                query: {
                    status: '',
                    is_show: '',
                    create_time: '',
                    keyword: '',
                    page: 1,
                    list_rows: 10,
                },
                select_type_array: [],

            };
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*获取列表*/
            getTableList() {
                this.loading = true
                enrollList(this.query).then((result)=>{
                    this.loading = false
                    this.tableData = result.data.list
                    this.total = result.data.count
                })
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },
            // 详情
            handleDetail(row){
                this.$refs['detail'].showDialog(row)
            },
            // 添加
            handleAdd(){
                this.$refs['edit'].showDialog()
            },
            // 编辑
            handleEdit(row) {
                this.$refs['edit'].showDialog(row)
            },
            // 作品管理
            handleCmpe(row){
                this.$refs['cmpe'].showDialog(row)
                // this.$router.push({
                //     path: '/education/activity/cmpe/index',
                //     query: {
                //         vote_id: row.vote_id,
                //         scene: 'list'
                //     }
                // });
            },
            // 审核
            handlAudit(row){
                let data = {
                    audit_id: 0,
                    target_id: row.vote_id,
                    audit_type: 2, // 评选投票
                }
                if(row.audit!==null && row.audit.audit_id > 0){
                    data.audit_id = row.audit.audit_id
                }
                this.$refs['audit'].showDialog(data)
            },
            // 删除
            handleDelete(row) {
                if (row.vote_id) {
                    this.$confirm('确定要删除当前项吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        voteDel({ids: row.vote_id}).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.getTableList()
                        })
                    }).catch(() => {

                    });
                } else {
                    // if (this.selection.length > 0) {
                    //     this.$confirm('确定要删除选中项吗?', '提示', {
                    //         confirmButtonText: '确定',
                    //         cancelButtonText: '取消',
                    //         type: 'warning'
                    //     }).then(() => {
                    //         agentDel({ids: this.selectIds}).then((result)=>{
                    //             this.$message({type: 'success', message: result.msg});
                    //             this.list()
                    //         })
                    //     }).catch(() => {
                    //
                    //     });
                    //
                    // } else {
                    //     this.$message({type: 'error', message: '未选中任何项'});
                    // }
                }
            },
            //选择第几页
            handleCurrentChange(val) {
                this.query.page = val;
                this.getTableList();
            },
            //每页多少条
            handleSizeChange(val) {
                this.query.list_rows = val;
                this.getTableList();
            },
            // 切换题目类型时
            questionTypeChange(val){
               this.query.course_type = val
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/education/activity/enroll/index.vue